export default {
    /*apiUrlBase: 'http://localhost:8000',
    apiUrl: 'http://localhost:8000',
    url: 'https://otkrijderventu.com',
    storage: 'https://otkrijderventu.com/public/data',
    client_secret: 'eJrKvuh8dGnZ4C9DhL5ymJSzfojqih6WzGPmOhRT',
    client_id: 6*/

    apiUrlBase: 'https://cms.bitlab.host/api',
    apiUrl: 'https://cms.bitlab.host/api',
    url: 'https://otkrijderventu.com',
    storage: 'https://otkrijderventu.com/public/data',
    client_secret: 'xibOh9tb8auz5cev0Sfp5UJqahywyMHL0MdfrIW9',
    client_id: 2,
    token: 'AAAAyFnejDk:APA91bHbRh0nlhB9OsKJxmdmoH-R8jc4XP_qEJ0pvnOy4zkXwGWzfiimDT2QnhGqqfHsbRYxJe9VlazKoCmxQvtLaWAwE527v24cNBKMu7kjgOgeMmvK5puVrEXGPw5ejHlEoOyE8qfH'
}
